import type { ReactNode } from 'react';
import { cn } from '@/shared/utils/cn';

type Tone = 'brand' | 'amber' | 'emerald' | 'red' | 'indigo' | 'slate';

type Props = {
  label: string;
  value: ReactNode;
  hint?: ReactNode;
  icon?: ReactNode;
  tone?: Tone;
  className?: string;
};

const TONE_BG: Record<Tone, string> = {
  brand: 'bg-brand-50 text-brand-700',
  amber: 'bg-amber-50 text-amber-700',
  emerald: 'bg-emerald-50 text-emerald-700',
  red: 'bg-red-50 text-red-700',
  indigo: 'bg-indigo-50 text-indigo-700',
  slate: 'bg-slate-100 text-slate-700',
};

export const StatCard = ({ label, value, hint, icon, tone = 'brand', className }: Props) => (
  <div
    className={cn(
      'flex items-start gap-4 rounded-2xl border border-slate-200 bg-white p-5 shadow-card',
      className,
    )}
  >
    {icon && (
      <span className={cn('inline-flex h-11 w-11 items-center justify-center rounded-xl', TONE_BG[tone])}>
        {icon}
      </span>
    )}
    <div className="min-w-0 flex-1">
      <p className="text-xs font-medium uppercase tracking-wide text-ink-muted">{label}</p>
      <p className="mt-1 text-2xl font-semibold text-ink">{value}</p>
      {hint && <p className="mt-1 text-xs text-ink-muted">{hint}</p>}
    </div>
  </div>
);
